import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../../common/constants";
import { deleteDeviceUrl } from "../../../../config";
import { RootState } from "../../../../store";
import api from "../../../../api";

const DELETE_SUPER_ADMIN_DEVICE = "deleteSuperAdminDevice";

interface IDeleteSuperAdminDevicePayload {
  deviceId: string;
  organizationId: string;
}

interface IDeleteSuperAdminDeviceState {
  status: string;
  message: string | null;
  error: string | null;
}

const initialState: IDeleteSuperAdminDeviceState = {
  status: Status.IDLE,
  message: null,
  error: null,
};

export const deleteSuperAdminDevice = createAsyncThunk(
  DELETE_SUPER_ADMIN_DEVICE,
  async ({ deviceId, organizationId }: IDeleteSuperAdminDevicePayload, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        deleteDeviceUrl + `?deviceId=${encodeURIComponent(deviceId)}`,
        {
          headers: {
            organizationId,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to reclaim device";
      return rejectWithValue(errorMessage);
    }
  }
);

const superAdminDeleteDeviceSlice = createSlice({
  name: DELETE_SUPER_ADMIN_DEVICE,
  initialState,
  reducers: {
    resetDeleteSuperAdminDeviceStatus: (state) => {
      state.status = Status.IDLE;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteSuperAdminDevice.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(deleteSuperAdminDevice.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.message = action.payload?.message || null;
      })
      .addCase(deleteSuperAdminDevice.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = (action.payload as string) || action.error.message || null;
      });
  },
});

export const { resetDeleteSuperAdminDeviceStatus } = superAdminDeleteDeviceSlice.actions;

export const selector = (state: RootState) => state.superAdminDeleteDeviceApi;

export const reducer = superAdminDeleteDeviceSlice.reducer;